import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_methods: {
    delivery: 'Entrega',
    pickup: 'Para levar',
  },
  asap: 'ASAP',
  unavailable: 'Indisponível',
  ready_in_time: 'Pronto em {{time}} min',
  locations: {
    [ORDER_METHODS.DELIVERY]: 'Entrega em {{address}}',
    [ORDER_METHODS.PICKUP]: 'Para levar em {{address}}',
  },
  buttons: {
    change: 'Alterar',
    see_hours: 'Ver horário',
    change_location: 'Alterar localização',
    change_time: 'Alterar hora',
  },
};
